import MainMenu from '../components/MainMenu';
import TechTypeLogo from '../components/TechTypeLogo';

const Home = () => {
    return (
        <div>
            <TechTypeLogo/>
            <MainMenu />
        </div>
    );
};

export default Home;
